import { render, staticRenderFns } from "./ResultPaperTitle.vue?vue&type=template&id=2bda6f4e&scoped=true&"
import script from "./ResultPaperTitle.vue?vue&type=script&lang=js&"
export * from "./ResultPaperTitle.vue?vue&type=script&lang=js&"
import style0 from "./ResultPaperTitle.vue?vue&type=style&index=0&id=2bda6f4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda6f4e",
  null
  
)

export default component.exports